import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Table,
  Input,
  Modal,
  message,
  Collapse,
  Alert,
  Select,
  Tag,
  Tooltip,
} from "antd";
import { usrRole } from "../../utils/dataUtil";
import { API_BASE } from "../../utils/contrains";
import {
  getSSPAcademicYear,
  formateDate_YMD,
  formateDateDbT_YMD,
} from "../../utils/dateUtil";
import {
  req_list_employees_all_public,
  req_list_ssp_planner_studentsource_academicSystem_search,
  req_list_ssp_planner_depart,
  req_delete_ssp_school_target_detail,
  req_edit_ssp_school_target_detail,
  req_list_ssp_target_principal,
  req_list_ssp_school_source_detail,
  req_list_ssp_school_source_main_academicSystem,
  req_add_school_plan_detail,
  req_downloadfile_ssp_depart_plan_detail_academicSystem,
} from "../../api";
import SchoolJuniorCustomizeModal from "./school-junior-customize-modal";
import DepartmentPrincipalSearchModal from "./department-principal-search-modal";
const { Panel } = Collapse;

class StudentDepartmentJuniorEditList extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    planAcademicYear: getSSPAcademicYear(new Date()),
    modify: true,
    loading: false,
    lock: false,
    userLevel: "NORMAL",
    employees: [],
    data: [],
    row: {
      Gid: "",
      YearMonth: "",
      PlanAcademicYear: "",
      AcademicSystem: "七技",
      UniversityCode: "1051",
      CollegeCode: "",
      TargetDepartmentCode: "",
      PrincipalCode: "",
      SourceCode: "",
      HighSchoolCode: "",
      SourceDepartmentCode: "",
      NumberOfPeople: 0,
      RecordCreatorId: "",
      RecordEditorId: "",
    },
    obj: {},
    colleges: [{ label: "藝術學院", value: "63" }],
    targetdeparts: [
      { value: "19", label: "美術系", group: "63" },
      { value: "20", label: "音樂系", group: "63" },
      { value: "21", label: "舞蹈系", group: "63" },
    ],
    targetdepartlist: [],
    targetprincipals: [],
    sourcehighSchools: [],
    sourcedeparts: [],
    academicSystems: [{ label: "七技", value: "七技" }],
    sourceCodes: [
      { value: "BA", label: "藝術單招(B1)" },
    ],
    viewStatus: [
      { value: "NEW", label: "今日新增" },
      { value: "SELF", label: "僅限本人規劃" },
      { value: "ALL", label: "所有數據" },
    ],
    selectedCountyCityName: "NONE",
    selectedCollege: "NONE",
    selectedTargetdepart: "NONE",
    selectedAcademicSystem: "七技",
    selectedTargetprincipal: "NONE",
    selectedSourceCode: "BA",
    selectedHighSchoolCode: "NONE",
    selectedSourceDepartmentCode: "000",
    selectedViewStatus: "ALL",
    canEndable: false,
    todayYMD: formateDate_YMD(new Date()),
    totalPlan: 0,
    totalConfident: 0,
    searchVal: "",
    isCustomizeModal: false,
    item: {},
  };

  constructor(props) {
    super(props);
    this.handleVisitedChange = this.handleVisitedChange.bind(this);
  }

  componentWillMount() {
    this.api_list_depart();
    this.api_list_studentsource();
    this.api_list_target_employees();
  }

  /////////////////////////
  api_list_target_depart = (value) => {
    const result = this.state.targetdeparts.filter(function (el) {
      return el.group === value;
    });
    const targetdepartlist = result.length > 0 ? result : [];
    this.setState({ targetdepartlist });
    //console.log("targetdepartlist:", targetdepartlist);
  };

  api_list_target_principal = async (targetDepart) => {
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    const result = await req_list_ssp_target_principal(
      userCode,
      userLevel,
      targetDepart,
      token
    );
    const targetprincipals = result.total > 0 ? result.data : [];
    this.setState({ targetprincipals });
    // console.log("targetprincipals:", targetprincipals);
  };

  api_list_target_employees = async () => {
    const { role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    const result = await req_list_employees_all_public(userCode, userLevel);
    const employees =
      result.total > 0
        ? result.data.map((employee) => ({
            value: employee.EmployeeId,
            label: employee.TwName,
          }))
        : [];
    // console.log("employees:", employees);
    this.setState({ employees });
  };

  api_list_source_highSchool = async () => {
    const { planAcademicYear, selectedCountyCityName } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    const result = await req_list_ssp_school_source_main_academicSystem(
      userCode,
      userLevel,
      planAcademicYear,
      selectedCountyCityName,
      "國中",
      token
    );
    const sourcehighSchools = result.total > 0 ? result.data : [];
    this.setState({ sourcehighSchools });
  };

  api_list_source_depart = async () => {
    const { planAcademicYear, selectedHighSchoolCode } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    const result = await req_list_ssp_school_source_detail(
      userCode,
      userLevel,
      planAcademicYear,
      selectedHighSchoolCode,
      token
    );
    const sourcedeparts = result.total > 0 ? result.data : [];
    this.setState({ sourcedeparts });
  };

  api_list_depart = async () => {
    const { planAcademicYear } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    const result = await req_list_ssp_planner_depart(
      userCode,
      userLevel,
      planAcademicYear,
      token
    );
    if (result.total > 0) {
      const items = result.data;

      items.forEach((item) =>
        item.EducationalSystemTwName === "七技"
          ? this.setState({ canEndable: true })
          : ""
      );

      const selectedCollege = items[0].CollegeCode;
      const selectedTargetdepart = items[0].DeptmentRealCode;
      const selectedAcademicSystem = "七技";
      const targetdepartlist = [];
      targetdepartlist.push({
        value: items[0].DeptmentRealCode,
        label: items[0].DeptmentFullName,
      });
      this.setTargetprincipals(items[0].DeptmentRealCode);
      // const lock = result.total === 1 ? true : false;
      const lock = true;
      this.setState({
        loading: false,
        targetdepartlist,
        selectedCollege,
        selectedAcademicSystem,
        selectedTargetdepart,
        lock,
      });
    } else {
      const items = [];
      this.setState({ targetdepartlist: items, loading: false });
    }
  };

  api_list_studentsource = async () => {
    //console.log("work");
    const {
      planAcademicYear,
      selectedAcademicSystem,
      selectedViewStatus,
      searchVal,
    } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel, data: [], loading: true });
    const result =
      await req_list_ssp_planner_studentsource_academicSystem_search(
        userCode,
        userLevel,
        planAcademicYear,
        selectedAcademicSystem,
        selectedViewStatus,
        searchVal,
        token
      );
    if (result.total > 0) {
      const items = result.data;
      const totalPlan = items.reduce((accumulator, object) => {
        return accumulator + object.NumberOfPeople;
      }, 0);
      const totalConfident = items.reduce((accumulator, object) => {
        return accumulator + object.NumberConfident;
      }, 0);
      this.setState({ data: items, totalPlan, totalConfident, loading: false });
    } else {
      const items = [];
      this.setState({
        data: items,
        totalPlan: 0,
        totalConfident: 0,
        loading: false,
      });
    }
  };

  api_list_studentsource_noloading = async () => {
    //console.log("work");
    const {
      planAcademicYear,
      selectedAcademicSystem,
      selectedViewStatus,
      searchVal,
    } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel, data: [] });
    const result =
      await req_list_ssp_planner_studentsource_academicSystem_search(
        userCode,
        userLevel,
        planAcademicYear,
        selectedAcademicSystem,
        selectedViewStatus,
        searchVal,
        token
      );
    if (result.total > 0) {
      const items = result.data;
      const totalPlan = items.reduce((accumulator, object) => {
        return accumulator + object.NumberOfPeople;
      }, 0);
      const totalConfident = items.reduce((accumulator, object) => {
        return accumulator + object.NumberConfident;
      }, 0);
      this.setState({ data: items, totalPlan, totalConfident });
    } else {
      const items = [];
      this.setState({
        data: items,
        totalPlan: 0,
        totalConfident: 0,
      });
    }
  };

  api_delete_item = async (key) => {
    const { token } = this.props.user;
    const result = await req_delete_ssp_school_target_detail(key, token);

    if (result.status === "success") {
      this.handle_data_refresh();
    } else {
    }
  };

  api_edit_item = async (row) => {
    const { token, userCode } = this.props.user;
    row.RecordEditorId = userCode;
    await req_edit_ssp_school_target_detail(row, token);
    this.handle_data_refresh();
  };

  api_add_item = async (item) => {
    const { token } = this.props.user;
    const result = await req_add_school_plan_detail(item, token);
    if (result.status === "success") {
      // console.log(result)
      this.handle_data_refresh();
      message.success(result.message);
    } else {
      message.error(result.message);
    }
  };

  api_downloadfile_items = async () => {
    const { userLevel, planAcademicYear, selectedTargetdepart } = this.state;
    const { token, userCode } = this.props.user;

    // download file data
    const fileUrl =
      await req_downloadfile_ssp_depart_plan_detail_academicSystem(
        userCode,
        userLevel,
        planAcademicYear,
        selectedTargetdepart,
        "七技",
        token
      );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  setTargetdeparts = (value) => {
    this.api_list_target_depart(value);
  };

  setTargetprincipals = (value) => {
    this.api_list_target_principal(value);
  };

  //////////
  handle_data_refresh = () => {
    this.api_list_studentsource();
    //this.api_list_studentsource_noloading();
    // console.log("refresh");
  };

  handle_show_ui_modal = (modal, item) => {
    //  console.log("handle_show_ui_modal");
    const { Gid } = item;
    switch (modal) {
      case "add":
        this.handle_data_refresh();
        break;
      case "delete":
        Modal.confirm({
          title: `您確定刪除此筆生源規劃`,
          onOk: () => {
            this.api_delete_item(Gid);
          },
        });
        break;
      case "download":
        this.api_downloadfile_items();
        break;
      case "customize":
        this.setState({ isCustomizeModal: true });
        break;
      case "PRINCIPAL":
        this.setState({ isEditPrincipalModal: true, item: item });
        break;
      default:
    }
  };

  handle_ui_field_change = (target_key, target_field, e) => {
    const { userCode } = this.props.user;
    let value = e.target.value;
    let getValue = parseInt(value, 10);

    if (isNaN(getValue)) {
      getValue = 0;
    }

    if (getValue <= 100 && getValue >= 0) {
      const item = {
        Gid: target_key,
        NumberOfPeople: getValue,
        NumberConfident: getValue,
        RecordEditorId: userCode,
        condition: target_field,
      };
      //console.log(target_key)
      this.api_edit_item(item);
    } else {
      message.info("數字僅能介於0至100");
    }
  };

  //////////
  handleChange = (event) => {
    const { row } = this.state;
    Object.keys(row).forEach((propertyName) => {
      if (event.target.id === propertyName && event.target.value !== null) {
        row[propertyName] = event.target.value.trim();
      }
    });
    this.setState({ row });
    //console.log("handleChange", row);
  };

  handleCollegeChange = (event) => {
    this.setState({
      selectedCollege: event.target.value,
      selectedTargetdepart: "NONE",
      selectedTargetprincipal: "NONE",
    });
    this.setTargetdeparts(event.target.value);
    //console.log(value);
  };

  handleTargetdepartChange = (event) => {
    const value = event.target.value;
    this.setState({
      selectedTargetdepart: value,
      selectedTargetprincipal: "NONE",
    });
    //console.log(value);
    this.setTargetprincipals(value);
  };

  // handleTargetprincipalChange = (event) => {
  //   const value = event.target.value;
  //   this.setState({
  //     selectedTargetprincipal: value,
  //   });
  // };

  handleAcademicSystem = (event) => {
    const value = event.target.value;
    this.setState({
      selectedAcademicSystem: value,
    });
  };

  handleselectedCountyCityNameChange = (event) => {
    const value = event.target.value;
    this.setState(
      {
        selectedCountyCityName: value,
        selectedHighSchoolCode: "NONE",
      },
      () => {
        this.api_list_source_highSchool();
      }
    );
  };

  handleHighSchoolCodeChange = (event) => {
    const value = event.target.value;
    this.setState({
      selectedHighSchoolCode: value,
    });
  };

  handleSourceCodeChange = (event) => {
    const value = event.target.value;
    this.setState({
      selectedSourceCode: value,
    });
  };

  handleNumberOfPeople = (event) => {
    const value = event.target.value;
    this.setState({
      setNumberOfPeople: value,
    });
  };

  handleViewStatusChange = (event) => {
    const value = event.target.value;
    this.setState(
      {
        selectedViewStatus: value,
      },
      () => {
        this.handle_data_refresh();
      }
    );
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const {
      planAcademicYear,
      selectedCollege,
      selectedTargetdepart,
      selectedTargetprincipal,
      selectedAcademicSystem,
      selectedSourceCode,
      selectedHighSchoolCode,
      selectedSourceDepartmentCode,
    } = this.state;

    const errors = [];

    if (selectedCollege === "NONE") {
      errors.push("規劃學院未選");
    }

    if (selectedTargetdepart === "NONE") {
      errors.push("規劃系所未選");
    }

    if (selectedTargetprincipal === "NONE") {
      errors.push("負責人未選");
    }

    if (selectedAcademicSystem === "NONE") {
      errors.push("招收學制未選");
    }

    if (selectedSourceCode === "NONE") {
      errors.push("招收方式未選");
    }
    if (selectedHighSchoolCode === "NONE") {
      errors.push("生源機構未選");
    }

    const row = this.state.row;
    if (row.NumberOfPeople === 0) {
      errors.push("規劃員額不能少於一人");
    }

    if (errors.length === 0) {
      const { userCode } = this.props.user;
      row.PlanAcademicYear = planAcademicYear;
      row.CollegeCode = selectedCollege;
      row.AcademicSystem = selectedAcademicSystem;
      row.TargetDepartmentCode = selectedTargetdepart;
      row.PrincipalCode = selectedTargetprincipal;
      row.SourceCode = selectedSourceCode;
      row.HighSchoolCode = selectedHighSchoolCode;
      row.SourceDepartmentCode = selectedSourceDepartmentCode;
      row.RecordEditorId = userCode;
      row.RecordCreatorId = userCode;
      console.log(row);
      this.api_add_item(row);
    } else {
      let info = errors.join(",");
      message.error(info);
    }
  };

  handleSearchChange = (event) => {
    const value = event.target.value;
    this.setState({
      searchVal: value,
    });
  };

  handleVisitedChange(event, item) {
    const { value } = event.target;
    const { Gid } = item;
    const { userCode } = this.props.user;
    const row = {
      Gid: Gid,
      VisitedStatus: value,
      VistedEditorId: userCode,
      condition: "VISITED",
    };
    this.api_edit_item(row);
  }

  handleEmployeeChange = (value) => {
    console.log(`selected ${value}`);
    this.setState({
      selectedTargetprincipal: value,
    });
  };

  onEmployeeSearch = (value) => {
    //console.log("search:", value);
  };

  render() {
    const {
      canEndable,
      planAcademicYear,
      data,
      loading,
      lock,
      academicSystems,
      colleges,
      targetdepartlist,
      // targetprincipals,
      sourcehighSchools,
      sourceCodes,
      selectedAcademicSystem,
      selectedCollege,
      selectedTargetdepart,
      selectedTargetprincipal,
      selectedCountyCityName,
      selectedHighSchoolCode,
      selectedSourceCode,
      todayYMD,
      viewStatus,
      selectedViewStatus,
      totalPlan,
      totalConfident,
      searchVal,
      employees,
      isCustomizeModal,
      isEditPrincipalModal,
      item,
    } = this.state;
    const { NumberOfPeople } = this.state.row;
    const columns = [
      {
        title: "操作",
        width: "80px",
        render: (item) => {
          return (
            <>
              <Tooltip
                title="刪除"
                placement="rightTop"
                color={"purple"}
                key={"purple"}
              >
                <button
                  className="btn btn-dark btn-sm"
                  style={{ width: "32px" }}
                  onClick={() => this.handle_show_ui_modal("delete", item)}
                >
                  <i className="fas fa-trash-alt"></i>
                </button>
              </Tooltip>{" "}
              <Tooltip
                title="更換"
                placement="rightTop"
                color={"purple"}
                key={"purple"}
              >
                <button
                  className="btn btn-dark btn-sm"
                  style={{ width: "32px" }}
                  onClick={() => this.handle_show_ui_modal("PRINCIPAL", item)}
                >
                  <i className="fa fa-cog"></i>
                </button>
              </Tooltip>
            </>
          );
        },
      },
      {
        title: "學制",
        responsive: ["md"],
        align: "center",
        dataIndex: "AcademicSystem",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "學院",
        responsive: ["md"],
        dataIndex: "CollegeName",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "系所",
        responsive: ["md"],
        dataIndex: "TargetDepartmentName",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "負責人",
        align: "center",
        dataIndex: "TwName",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "生源縣市",
        responsive: ["md"],
        align: "center",
        dataIndex: "CountyCityName",
        render(text, record) {
          const { RecordCreateDateTime } = record;
          return {
            props: {
              style: {
                fontWeight: 900,
                background:
                  todayYMD === formateDateDbT_YMD(RecordCreateDateTime)
                    ? "#90ee90"
                    : "#FFFFFF",
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "生源機構",
        dataIndex: "HighSchoolTwName",
        render(text, record) {
          const { RecordCreateDateTime } = record;
          return {
            props: {
              style: {
                fontWeight: 900,
                background:
                  todayYMD === formateDateDbT_YMD(RecordCreateDateTime)
                    ? "#90ee90"
                    : "#FFFFFF",
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "生源科班",
        responsive: ["md"],
        dataIndex: "HighSchoolDepartmentName",
        render(text, record) {
          const { RecordCreateDateTime } = record;
          return {
            props: {
              style: {
                fontWeight: 900,
                background:
                  todayYMD === formateDateDbT_YMD(RecordCreateDateTime)
                    ? "#90ee90"
                    : "#FFFFFF",
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "招生管道",
        align: "center",
        dataIndex: "SourceName",
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "規劃員額",
        width: "50px",
        align: "right",
        fixed: "true",
        render: (item) => {
          const { NumberOfPeople, Gid } = item;
          return (
            <>
              <Input
                type="number"
                placeholder="人數"
                style={{
                  width: "60px",

                  backgroundColor: "LightYellow",
                  fontWeight: 900,
                  color: "blue",
                }}
                defaultValue={NumberOfPeople}
                onChange={(e) => this.handle_ui_field_change(Gid, "QUOTA", e)}
              />
            </>
          );
        },
      },
      {
        title: "預收員額",
        width: "50px",
        align: "right",
        fixed: "true",
        render: (item) => {
          const { NumberConfident, Gid } = item;
          return (
            <>
              <Input
                type="number"
                placeholder="人數"
                style={{
                  width: "60px",
                  fontWeight: 900,
                  backgroundColor: "LightYellow",
                  color: "green",
                }}
                defaultValue={NumberConfident}
                onChange={(e) => this.handle_ui_field_change(Gid, "QUOTB", e)}
              />
            </>
          );
        },
      },
      {
        title: "實地拜訪",
        width: "70px",
        responsive: ["md"],
        align: "center",
        fixed: "true",
        render: (item) => {
          const { VisitedStatus } = item;
          return (
            <>
              {VisitedStatus === "Y" ? (
                <Tag color="green">已訪</Tag>
              ) : (
                <Tag color="orange">待訪</Tag>
              )}

              {/* <select
                className="form-control"
                style={{
                  width: "90px",
                  display: "inline-block",
                  backgroundColor:
                    VisitedStatus === "Y" ? "LightGreen" : "LightYellow",
                }}
                onChange={(e) => this.handleVisitedChange(e, item)}
                value={VisitedStatus}
              >
                <option value="N" key="N">
                  待訪
                </option>
                <option value="Y" key="Y">
                  已訪
                </option>
              </select> */}
            </>
          );
        },
      },
    ];

    return (
      <>
        <div>
          <div
            style={{
              display: "inline-block",
            }}
          >
            <div className="form-group">
              <Input
                placeholder="規劃年度"
                style={{
                  width: 55,
                  height: 39,
                  margin: "0 5px",
                  color: "red",
                }}
                onChange={(event) =>
                  this.setState({ planAcademicYear: event.target.value })
                }
                value={planAcademicYear}
                readOnly={true}
                disabled={true}
              />
              <select
                className="form-control"
                style={{ width: "80px", display: "inline-block" }}
                onChange={this.handleAcademicSystem}
                disabled={lock}
              >
                <option
                  value={"NONE"}
                  selected={
                    selectedTargetprincipal === "NONE" ? "selected" : ""
                  }
                >
                  請選擇
                </option>
                {academicSystems.map((item) => (
                  <option
                    value={item.value}
                    selected={
                      item.value === selectedAcademicSystem ? "selected" : ""
                    }
                  >
                    {item.label}
                  </option>
                ))}
              </select>
              <select
                className="form-control"
                style={{ width: "160px", display: "inline-block" }}
                onChange={this.handleCollegeChange}
                disabled={lock}
              >
                {colleges.map((item) => (
                  <option
                    value={item.value}
                    selected={item.value === selectedCollege ? "selected" : ""}
                  >
                    {item.label}
                  </option>
                ))}
              </select>
              <select
                className="form-control"
                style={{ width: "180px", display: "inline-block" }}
                onChange={this.handleTargetdepartChange}
                disabled={lock}
              >
                <option
                  value={"NONE"}
                  selected={
                    selectedTargetprincipal === "NONE" ? "selected" : ""
                  }
                >
                  請選擇
                </option>
                {targetdepartlist.map((item) => (
                  <option
                    value={item.value}
                    selected={
                      item.value === selectedTargetdepart ? "selected" : ""
                    }
                  >
                    {item.label}
                  </option>
                ))}
              </select>
              <select
                className="form-control"
                style={{
                  width: "150px",
                  backgroundColor: "#FDEDEC",
                  display: "inline-block",
                }}
                onChange={this.handleViewStatusChange}
              >
                {viewStatus.map((item) => (
                  <option
                    value={item.value}
                    selected={
                      item.value === selectedViewStatus ? "selected" : ""
                    }
                  >
                    {item.label}
                  </option>
                ))}
              </select>
              <input
                type="text"
                className="form-control"
                style={{
                  width: "120px",
                  display: "inline-block",
                  backgroundColor: "#FFFFE0",
                }}
                name="searchVal"
                id="searchVal"
                defaultValue={searchVal}
                disabled={!canEndable}
                placeholder="機構名稱篩選"
                onChange={this.handleSearchChange}
              />
              <button
                className={canEndable ? "btn btn-info" : "btn btn-light"}
                onClick={this.handle_data_refresh}
                disabled={!canEndable}
                style={{
                  marginLeft: "2px",
                  display: "inline-block",
                  marginBottom: "6px",
                }}
              >
                <i className="fas fa-sync-alt"></i>
              </button>
              <button
                className={canEndable ? "btn btn-info" : "btn btn-light"}
                onClick={() => this.handle_show_ui_modal("download", {})}
                style={{ marginLeft: "2px", marginBottom: "6px" }}
                disabled={!canEndable}
              >
                <i className="fas fa-cloud-download-alt"></i>
              </button>
              <br></br>
              <Collapse>
                <Panel header="新增單筆" key="1">
                  <>
                    <form onSubmit={this.handleSubmit} className="form-inline">
                      {" "}
                      <Select
                        showSearch
                        placeholder="請填選負責人"
                        style={{
                          width: "140px",
                          display: "inline-block",
                        }}
                        className="background-color"
                        onChange={this.handleEmployeeChange}
                        onSearch={this.onEmployeeSearch}
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toUpperCase()
                            .includes(input.toUpperCase())
                        }
                        options={employees}
                      />
                      {/* <select
                        className="form-control"
                        style={{
                          width: "160px",
                          display: "inline-block",
                          backgroundColor: "LightCyan",
                        }}
                        onChange={this.handleTargetprincipalChange}
                      >
                        <option
                          value={"NONE"}
                          selected={
                            selectedTargetprincipal === "NONE" ? "selected" : ""
                          }
                        >
                          請選擇負責人
                        </option>
                        {targetprincipals.length > 0 ? (
                          <>
                            {targetprincipals.map((item) => (
                              <option
                                value={item.EmployeeId}
                                selected={
                                  item.EmployeeId === selectedTargetprincipal
                                    ? "selected"
                                    : ""
                                }
                              >
                                {item.EmployeeId}-{item.TwName}
                              </option>
                            ))}
                          </>
                        ) : (
                          ""
                        )}
                      </select> */}
                      <select
                        className="form-control"
                        style={{
                          width: 120,
                          backgroundColor: "LightCyan",
                          display: "inline-block",
                        }}
                        onChange={this.handleselectedCountyCityNameChange}
                      >
                        <option
                          value="NONE"
                          selected={
                            selectedCountyCityName === "NONE" ? "selected" : ""
                          }
                        >
                          生源縣市
                        </option>
                        <option
                          value="臺北市"
                          selected={
                            selectedCountyCityName === "臺北市"
                              ? "selected"
                              : ""
                          }
                        >
                          臺北市
                        </option>
                        <option
                          value="新北市"
                          selected={
                            selectedCountyCityName === "新北市"
                              ? "selected"
                              : ""
                          }
                        >
                          新北市
                        </option>
                        <option
                          value="基隆市"
                          selected={
                            selectedCountyCityName === "基隆市"
                              ? "selected"
                              : ""
                          }
                        >
                          基隆市
                        </option>
                        <option
                          value="宜蘭縣"
                          selected={
                            selectedCountyCityName === "宜蘭縣"
                              ? "selected"
                              : ""
                          }
                        >
                          宜蘭縣
                        </option>
                        <option
                          value="花蓮縣"
                          selected={
                            selectedCountyCityName === "花蓮縣"
                              ? "selected"
                              : ""
                          }
                        >
                          花蓮縣
                        </option>
                        <option
                          value="臺東縣"
                          selected={
                            selectedCountyCityName === "臺東縣"
                              ? "selected"
                              : ""
                          }
                        >
                          臺東縣
                        </option>
                        <option
                          value="桃園市"
                          selected={
                            selectedCountyCityName === "桃園市"
                              ? "selected"
                              : ""
                          }
                        >
                          桃園市
                        </option>
                        <option
                          value="新竹市"
                          selected={
                            selectedCountyCityName === "新竹市"
                              ? "selected"
                              : ""
                          }
                        >
                          新竹市
                        </option>
                        <option
                          value="新竹縣"
                          selected={
                            selectedCountyCityName === "新竹縣"
                              ? "selected"
                              : ""
                          }
                        >
                          苗栗縣
                        </option>
                        <option
                          value="苗栗縣"
                          selected={
                            selectedCountyCityName === "苗栗縣"
                              ? "selected"
                              : ""
                          }
                        >
                          苗栗縣
                        </option>
                        <option
                          value="臺中市"
                          selected={
                            selectedCountyCityName === "臺中市"
                              ? "selected"
                              : ""
                          }
                        >
                          臺中市
                        </option>
                        <option
                          value="彰化縣"
                          selected={
                            selectedCountyCityName === "彰化縣"
                              ? "selected"
                              : ""
                          }
                        >
                          彰化縣
                        </option>
                        <option
                          value="南投縣"
                          selected={
                            selectedCountyCityName === "南投縣"
                              ? "selected"
                              : ""
                          }
                        >
                          南投縣
                        </option>
                        <option
                          value="雲林縣"
                          selected={
                            selectedCountyCityName === "雲林縣"
                              ? "selected"
                              : ""
                          }
                        >
                          雲林縣
                        </option>
                        <option
                          value="嘉義市"
                          selected={
                            selectedCountyCityName === "嘉義市"
                              ? "selected"
                              : ""
                          }
                        >
                          嘉義市
                        </option>
                        <option
                          value="嘉義縣"
                          selected={
                            selectedCountyCityName === "嘉義縣"
                              ? "selected"
                              : ""
                          }
                        >
                          嘉義縣
                        </option>
                        <option
                          value="臺南市"
                          selected={
                            selectedCountyCityName === "臺南市"
                              ? "selected"
                              : ""
                          }
                        >
                          臺南市
                        </option>
                        <option
                          value="高雄市"
                          selected={
                            selectedCountyCityName === "高雄市"
                              ? "selected"
                              : ""
                          }
                        >
                          高雄市
                        </option>
                        <option
                          value="屏東縣"
                          selected={
                            selectedCountyCityName === "屏東縣"
                              ? "selected"
                              : ""
                          }
                        >
                          屏東縣
                        </option>
                        <option
                          value="澎湖縣"
                          selected={
                            selectedCountyCityName === "澎湖縣"
                              ? "selected"
                              : ""
                          }
                        >
                          澎湖縣
                        </option>
                        <option
                          value="連江縣"
                          selected={
                            selectedCountyCityName === "連江縣"
                              ? "selected"
                              : ""
                          }
                        >
                          連江縣
                        </option>
                        <option
                          value="金門縣"
                          selected={
                            selectedCountyCityName === "金門縣"
                              ? "selected"
                              : ""
                          }
                        >
                          金門縣
                        </option>
                      </select>
                      <select
                        className="form-control"
                        style={{
                          width: "200px",
                          display: "inline-block",
                          backgroundColor: "LightCyan",
                        }}
                        onChange={this.handleHighSchoolCodeChange}
                      >
                        <option
                          value={"NONE"}
                          selected={
                            selectedHighSchoolCode === "NONE" ? "selected" : ""
                          }
                        >
                          生源機構
                        </option>
                        {sourcehighSchools.length > 0 ? (
                          <>
                            {sourcehighSchools.map((item) => (
                              <option
                                value={item.HighSchoolCode}
                                selected={
                                  item.HighSchoolCode === selectedHighSchoolCode
                                    ? "selected"
                                    : ""
                                }
                              >
                                {item.HighSchoolTwName}
                              </option>
                            ))}
                          </>
                        ) : (
                          ""
                        )}
                      </select>
                      <select
                        className="form-control"
                        style={{
                          width: "160px",
                          display: "inline-block",
                          backgroundColor: "LightCyan",
                        }}
                        onChange={this.handleSourceCodeChange}
                      >
                        <option
                          value={"NONE"}
                          selected={
                            selectedSourceCode === "NONE" ? "selected" : ""
                          }
                        >
                          招收方式
                        </option>
                        {sourceCodes.length > 0 ? (
                          <>
                            {sourceCodes.map((item) => (
                              <option
                                value={item.value}
                                selected={
                                  item.value === selectedSourceCode
                                    ? "selected"
                                    : ""
                                }
                              >
                                {item.label}
                              </option>
                            ))}
                          </>
                        ) : (
                          ""
                        )}
                      </select>
                      <input
                        type="number"
                        className="form-control"
                        style={{
                          width: "60px",
                          backgroundColor: "LightYellow",
                          display: "inline-block",
                        }}
                        name="NumberOfPeople"
                        id="NumberOfPeople"
                        disabled={!canEndable}
                        defaultValue={NumberOfPeople}
                        placeholder="請輸人數"
                        onChange={this.handleChange}
                      />
                      <button
                        type="submit"
                        className={
                          canEndable ? "btn btn-info" : "btn btn-light"
                        }
                        disabled={!canEndable}
                        style={{
                          marginLeft: "2px",
                          marginBottom: "6px",
                        }}
                      >
                        <i className="fa fa-plus"></i>
                      </button>
                    </form>
                    <button
                      className="btn btn-danger"
                      onClick={() => this.handle_show_ui_modal("customize", {})}
                      style={{ marginLeft: "2px", marginBottom: "6px" }}
                    >
                      <i className="fa fa-plus"></i> 擴增其他機構(例：XX畫室)
                    </button>
                  </>
                </Panel>
              </Collapse>
            </div>
          </div>
          <div style={{ textAlign: "right" }}>
            <Alert
              message={
                totalPlan > 0 ? (
                  <>
                    <span style={{ color: "blue", fontWeight: 900 }}>
                      規劃：{totalPlan} 員
                    </span>{" "}
                    |{" "}
                    <span style={{ color: "green", fontWeight: 900 }}>
                      預收：{totalConfident} 員
                    </span>{" "}
                    |{" "}
                    <span style={{ color: "red", fontWeight: 900 }}>
                      預達率： {((totalConfident / totalPlan) * 100).toFixed(0)}
                      %
                    </span>
                  </>
                ) : (
                  <></>
                )
              }
              type="error"
            />
          </div>
          <Table
            bordered
            columns={columns}
            dataSource={data}
            pagination={false}
            loading={loading}
          />
          <Modal
            destroyOnClose={true}
            visible={isCustomizeModal}
            width={"450px"}
            onOk={() => {
              this.setState(
                {
                  isCustomizeModal: false,
                  selectedCountyCityName: "NONE",
                },
                () => {
                  this.api_list_source_highSchool();
                }
              );
            }}
            onCancel={() => {
              this.setState({ isCustomizeModal: false });
            }}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            <SchoolJuniorCustomizeModal />
          </Modal>
          <Modal
            destroyOnClose={true}
            visible={isEditPrincipalModal}
            width={400}
            onOk={() => {
              this.setState({ isEditPrincipalModal: false });
              this.handle_data_refresh();
            }}
            onCancel={() => {
              this.setState({ isEditPrincipalModal: false });
            }}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            <DepartmentPrincipalSearchModal source={item} />
          </Modal>
        </div>
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(StudentDepartmentJuniorEditList);
